import { defineNuxtPlugin } from "#imports";

export default defineNuxtPlugin((nuxtApp) => {
	const appEnv = useRuntimeConfig().public.appEnv;
	if(appEnv === "prod" && false){
		if (process.client) {
			//const runtimeConfig = useRuntimeConfig();
			//const appEnv = runtimeConfig.appEnv;
			const ignoreRoutes = ['/widget/instituicao','/widget/allinstitutions','/lp/anima','/lp/fmu'];
			//inversão temporaria para acompanha a anima
			const route = useRoute()
			//const enabledRoutes = ['/lp/fmu','/lp/anima','/'];// '/lp/anima'

			if (!ignoreRoutes.includes(route.path)) {
				useHead(
					{
						script: [
							{
								hid: 'smartlook',
								children: `
								window.smartlook||(function(d) {
									var o=smartlook=function(){ o.api.push(arguments)},h=d.getElementsByTagName('head')[0];
									var c=d.createElement('script');o.api=new Array();c.async=true;c.type='text/javascript';
									c.charset='utf-8';c.src='https://web-sdk.smartlook.com/recorder.js';h.appendChild(c);
									})(document);
									smartlook('init', '99b7ad58f3aa45cdbc4e2f0e14dab6348269e7db', { region: 'eu' });
								`,
							}
						]
					}
				);
			}
		}
	}
});
